export default {"src":"/_next/static/media/rate.f621b617.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};